import { FormEvent, FormEventHandler } from 'react';
import { Form, HelperText, TextField, validators } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import styles from './index.module.scss';

const EditableEmail = ({
  handleSubmit,
  handleChange,
}: {
  handleSubmit: FormEventHandler<HTMLFormElement>;
  handleChange: (event: FormEvent<HTMLInputElement>) => void;
}) => {
  const { t } = useTranslation('Disconnect', { keyPrefix: 'contactInfo' });

  const validationRules = [
    validators.required({
      message: t('requiredField', { fieldName: t('email.fieldName') }),
    }),
    validators.email({ message: t('email.invalid') }),
  ];

  return (
    <Form
      validationMode="onSubmit"
      onSubmit={handleSubmit}
      id="email-form"
      className={styles['emailForm']}
    >
      <TextField
        validationRules={validationRules}
        required
        mt="8px"
        mb="16px"
        fluid
        id="email"
        name="email"
        onChange={handleChange}
      />
      <HelperText state="info" helpMessage={t('email.info')} />
    </Form>
  );
};

export default EditableEmail;
